// ChildMenu.js
import React, { Component } from 'react';
import { List, Typography, Divider } from 'antd';
import './help.scss';

const { Title, Paragraph } = Typography;

class ChildMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getMenuContent(menu) {
	switch (menu) {
		case 'Overview':
			return [
			  {
				title: "Domain Overview",
				description: "Manage your domain endpoints and traffic patterns:",
				items: [
				  "View active endpoints status",
				  "Monitor total routing rules",
				  "Check traffic patterns",
				  "Quick access to domain management"
				]
			  },
			  {
				title: "Dashboard Features",
				description: "Key features available on the overview page:",
				items: [
				  "Traffic routing rules overview",
				  "Traffic pattern visualization",
				  "Quick actions for configuration"
				]
			  }
			];
		  
		case 'DynamicLink':
			return [
				{
					title: "Dynamic Link Management",
					description: "Manage your dynamic shortened links and configurations:",
					items: [
						"Create new shortened links",
						"Customize link settings",
						"Track link performance",
						"View link creation dates"
					]
				},
				{
					title: "Dynamic Link Operations",
					description: "Available actions for shortened links:",
					items: [
						"Delete link configurations",
						"Update link"
					]
				}
			];
		
		
	  default:
		return [
		  {
			title: "Documentation",
			description: "Please select a topic from the menu to view its documentation.",
			items: []
		  }
		];
	}
  }

  render() {
    const { menu } = this.props;
    const content = this.getMenuContent(menu);

    return (
      <div className="help-content">
        <List
          itemLayout="vertical"
          dataSource={content}
          renderItem={item => (
            <List.Item>
              <Title level={4}>{item.title}</Title>
              <Paragraph>{item.description}</Paragraph>
              <List
                dataSource={item.items}
                renderItem={subItem => (
                  <List.Item>
                    • {subItem}
                  </List.Item>
                )}
              />
              <Divider />
            </List.Item>
          )}
        />
      </div>
    );
  }
}

export default ChildMenu;
